export default __webpack_public_path__ + "static/media/weekly_mind_body.bdfd1155.png";